<section class="content-layout">
  <div class="main">
    <!-- Header -->
    <header class="task-template__header px-10 py-8">
      <!-- Title & Breadcrumb -->
      <div class="title">
        <div class="breadcrumb">
          <span class="path"><a [routerLink]="['../']">Sheet Templates</a><span class="separator">/</span>Edit</span>
        </div>
        <h1 class="mt-0">{{ sheetTemplate.name }}</h1>
      </div>

      <!-- Main actions -->
      <div class="main-actions">
        <!-- Add Template button -->
        <button mat-flat-button [color]="'primary'" (click)="save()">
          <mat-icon [svgIcon]="'save'"></mat-icon>
          Save
        </button>

        <button class="more-menu ml-2" mat-icon-button [matMenuTriggerFor]="moreMenu">
          <mat-icon [svgIcon]="'more_vert'"></mat-icon>
        </button>

        <mat-menu #moreMenu="matMenu">
          <button mat-menu-item (click)="deleteSheetTemplate()">
            <mat-icon [svgIcon]="'delete'"></mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>
      </div>
    </header>

    <main class="task-template__form px-10 py-5">
      <!-- Sheet Template Edit Form -->
      <form [formGroup]="sheetTemplateForm">
        <div class="flex flex-col my-4 px-8 py-10 bg-card shadow rounded overflow-hidden">
          <p class="text-lg font-medium">Template Name</p>
          <p class="text-secondary">Set the name of the template</p>
          <mat-divider
            role="separator"
            class="mat-divider mt-8 mb-10 mat-divider-horizontal"
            aria-orientation="horizontal"
          ></mat-divider>

          <div class="flex-auto min-w-64">
            <!-- Template Name -->
            <div class="flex flex-col gt-xs:flex-row mt-3">
              <mat-form-field class="subject flex-auto">
                <mat-label>Template Name</mat-label>
                <input matInput [formControlName]="'name'" />
              </mat-form-field>
            </div>

            <!-- Template Description -->
            <div class="flex flex-col gt-xs:flex-row mt-3">
              <mat-form-field class="treo-mat-textarea treo-mat-no-subscript flex-auto">
                <mat-label>Description</mat-label>
                <textarea matInput treoAutogrow [formControlName]="'description'" [spellcheck]="false"></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>

      <iframe
        class="block w-full h-screen bg-card shadow rounded"
        [src]="sheetTemplate.embed_url | safe"
        frameborder="0"
        scrolling="yes"
        seamless="seamless"
      ></iframe>
    </main>
  </div>
</section>
